import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { 
  Calendar, 
  ChevronLeft, 
  ChevronRight, 
  GraduationCap as MallaIcon, 
  LogOut
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cerrarSesion } from "../../../store/slices/usuario.slice";

export const DocenteMenuSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleLogout = () => {
    dispatch(cerrarSesion());
    navigate("/");
  };

  const getLinkClasses = (isActive) => {
    return `flex items-center gap-3 px-4 py-3 transition-colors relative ${
      isActive 
        ? "bg-theme-blue text-white" 
        : "text-slate-700 hover:bg-gray-100"
    }`;
  };

  return (
    <nav
      id={"sidebar"}
      className={`flex flex-col min-h-screen bg-white text-slate-800 border-r border-gray-200 transition-all duration-300 ${isCollapsed ? "min-w-[4rem]" : "min-w-[13rem]"}`}
    >
      {/* Botón para colapsar/expandir */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="p-3 hover:bg-gray-100 transition-colors flex items-center justify-center border-b border-gray-200"
        title={isCollapsed ? "Expandir menú" : "Colapsar menú"}
      >
        {isCollapsed ? (
          <ChevronRight className="w-5 h-5 text-theme-blue" />
        ) : (
          <ChevronLeft className="w-5 h-5 text-theme-blue" />
        )}
      </button>

      <NavLink 
        to="/calendario-academico" 
        end={false}
        className={({ isActive }) => getLinkClasses(isActive)}
      >
        {({ isActive }) => (
          <>
            <Calendar className={`w-5 h-5 flex-shrink-0 ${isActive ? "text-white" : "text-theme-blue"}`} />
            {!isCollapsed && <span>Calendario Académico</span>}
            {isActive && !isCollapsed && (
              <div className="absolute right-0 top-0 bottom-0 w-1 bg-green-500"></div>
            )}
          </>
        )}
      </NavLink>

      <NavLink 
        to="/malla-curricular" 
        end={false}
        className={({ isActive }) => getLinkClasses(isActive)}
      >
        {({ isActive }) => (
          <>
            <MallaIcon className={`w-5 h-5 flex-shrink-0 ${isActive ? "text-white" : "text-theme-blue"}`} />
            {!isCollapsed && <span>Malla Curricular</span>}
            {isActive && !isCollapsed && (
              <div className="absolute right-0 top-0 bottom-0 w-1 bg-green-500"></div>
            )}
          </>
        )}
      </NavLink>
      
      <div className="mt-auto border-t border-gray-200">
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 hover:bg-red-50 transition-colors text-left text-red-600"
          title={isCollapsed ? "Salir" : ""}
        >
          <LogOut className="w-5 h-5 flex-shrink-0" />
          {!isCollapsed && <span>Salir</span>}
        </button>
      </div>
    </nav>
  );
};

